<template>
  <div class="fp-preferences-content">
    <div class="first-step">
      <img class="illustration img-fluid" src='@/assets/images/preferences_illustration.png' />

      <h5>
        {{ $lang.messages.preferences_welcome }}&trade;{{ $lang.messages.preferences_welcome_title }}
      </h5>

      <p>
        {{ $lang.messages.preferences_welcome_text }}
      </p>
    </div>
    <button type="button" class="action-btn continue-btn" @click="continueButtonClick">
      <span>
        {{ $lang.messages.preferences_continue }}
      </span>
    </button>
  </div>
</template>

<script>
  export default {
    name: "PreferencesWelcome",
    props: {
      continueButtonClick: {
        type: Function,
        required: true
      },
    }
  }
</script>
